import React, { useCallback } from "react";
import { Checkbox } from "semantic-ui-react";
import { spacing, typographyColors } from "../library/theme";

const container = {
  marginBottom: spacing.m,
};
const hintStyle = {
  display: "inline",
  color: typographyColors.defaultBody,
  fontSize: 16,
  marginLeft: spacing.xxs,
};
const labelStyle = {
  fontSize: 16,
};

export default function MockLevelFieldGroupItem({
  level,
  fields,
  setIsAllSelected,
  disabled,
}) {
  const handleChange = useCallback(
    (e) => {
      const levelId = Number(e.target.name);
      const idx = (fields?.getAll() || []).indexOf(levelId);

      if (idx > -1) {
        fields.remove(idx);
        setIsAllSelected(false);
      } else {
        fields.push(levelId);
      }
    },
    [fields],
  );

  return (
    <div style={container}>
      <Checkbox
        id={`${level.name}-${level.id}`}
        name={String(level.id)}
        label={
          <label style={labelStyle}>
            {level.name}
            <div style={hintStyle}>{level.hint}</div>
          </label>
        }
        onChange={handleChange}
        checked={(fields?.getAll() || []).indexOf(level.id) > -1}
        disabled={disabled}
      />
    </div>
  );
}
